import { render, staticRenderFns } from "./UpdateAttachment.vue?vue&type=template&id=4e448a02&scoped=true"
import script from "./UpdateAttachment.vue?vue&type=script&lang=js"
export * from "./UpdateAttachment.vue?vue&type=script&lang=js"
import style0 from "./UpdateAttachment.vue?vue&type=style&index=0&id=4e448a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e448a02",
  null
  
)

export default component.exports